import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select, { components } from "react-select";
import translate from "../../services/translation";
import SelectIcon from "../Favourites/SelectIcon";


export default class ReactSelectAdapter extends Component {

    static propTypes = {
        name: PropTypes.string,
        defaultOptionLabel: PropTypes.string,
        options: PropTypes.array,
        selectedOption: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
        hasSpecialIcon: PropTypes.bool
    };

    handleUpdateEvent = (updateEvent) => {
        const event = {
            target: {
                name: this.props.name,
                value: updateEvent.value
            }
        };

        this.props.onChange(event);
    };


	render() {
        const {defaultOptionLabel, options, selectedOption, disabled} = this.props;

        const castOptions = options ? options.map(option => {
            return {value: option.uid || option.value, label: option.title || option.label};
        }) : [];

        const selectedOptionObject = selectedOption !== 0 ? castOptions.find(option => option.value === selectedOption) : selectedOption;

        const DropdownIndicator = props => {
            return (
                    <components.DropdownIndicator {...props}>
                        {this.props.hasSpecialIcon?(<SelectIcon/>):null}
                    </components.DropdownIndicator>
            );
        };

	    return (
            <Select
                value={selectedOptionObject}
                onChange={this.handleUpdateEvent}
                options={castOptions}
                isDisabled={disabled}
                placeholder={defaultOptionLabel}
                components={{DropdownIndicator}}
                isSearchable={ false }
                styles={ReactSelectAdapter.customStyles}
                classNamePrefix={'select-basic'}
                noOptionsMessage={() => translate('planner_list.no_options')}
            />
        );
	}

	static customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: 'none',
            borderRadius: 5,
            padding: 10,
            cursor: 'pointer',
            backgroundColor: state.isDisabled ? '#dad3c6' : state.isFocused ? '#dad3c6' : '#C0B39D',
            borderColor: state.isDisabled ? '#dad3c6' : state.isFocused ? '#dad3c6' : '#C0B39D',

            '&:hover': {
                boxShadow: 'none',
                borderColor: '#dad3c6',
                backgroundColor:  '#dad3c6',
            },
        }),

        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#A49271' : 'black',
            backgroundColor: '#EDE9E2',
            padding: 8,
            cursor: 'pointer',

            '&:hover': {
                color: '#A49271',
                backgroundColor: state.isFocused ? "#EDE9E2" : "#EDE9E2",
            },
        }),

        menu: provided  => ({
            ...provided ,
            backgroundColor: '#EDE9E2',
            border: '1px solid #A49271',
            marginTop: 10,
            padding: 7,
            borderRadius: 2,
            zIndex: 100,
        }),

        dropdownIndicator: (provided, state) => ({
            ...provided,
            marginLeft: 7,
            opacity: state.isDisabled ? '0.3' : state.isFocused ? '1' : '1',
        }),

        indicatorsContainer: () => ({
            marginRight: 7,
        }),

        indicatorSeparator: base => ({
            ...base,
            display: 'none',
        }),

        placeholder: base => ({
            ...base,
            color: '#191919',
        }),

        multiValueRemove: base => ({
            ...base,
            '&:hover': {
                backgroundColor: '#191919',
                color: 'white',
            },
        }),

        multiValueLabel: base => ({
            ...base,
            padding: '2px 3px 2px 6px',
        }),
    };
}



// WEBPACK FOOTER //
// ./src/components/Planner/ReactSelectAdapter.js